export const MenuAdmin = [
	{
		path: '/dashboard',
		icon: 'desktop',
		title: 'Dashboard',
		type: 'link'
	},
	{
		title: 'Data Master',
		icon: 'blackboard',
		type: 'sub',
		active: false,
		children: [
			{ path: '/main/jenis-aplikasi', title: 'Jenis Aplikasi', type: 'link' },
			{ path: '/main/jenis-aplikasi-perangkat', title: 'Jenis Aplikasi Perangkat', type: 'link' },
			{ path: '/main/jenis-surat', title: 'Jenis Surat', type: 'link' },
			{ path: '/main/version-app', title: 'Version App', type: 'link' },
		]
	},
	{
		title: 'Konfigurasi',
		icon: 'hummer',
		type: 'sub',
		active: false,
		children: [
			{ path: '/main/konfigurasi-alamat', title: 'Konfigurasi Alamat', type: 'link' },
			{ path: '/main/konfigurasi-desa', title: 'Konfigurasi Desa', type: 'link' },
		]
	},
	{ 
		path: '/main/request-surat', 
		icon: 'files',
		title: 'Request Surat', 
		type: 'link' 
	},
	{
		title: 'Digidesa Landing',
		icon: 'server',
		type: 'sub',
		active: false,
		children: [
			{ path: '/main/bumdes', title: 'Data Bumdes', type: 'link' },
			{ path: '/main/partner', title: 'Data Partner', type: 'link' },
			{ path: '/main/daftar-desa', title: 'Daftar Desa', type: 'link' },
			{ path: '/main/data-klik', title: 'Data Klik', type: 'link' },
		]
	},
];
